import { useCallback } from 'react';
import { set } from 'react-hook-form';

export const useYupValidationResolver = (validationSchema: any) =>
  useCallback(
    async (data: any) => {
      try {
        const values = await validationSchema.validate(data, {
          abortEarly: false,
        });

        return {
          values,
          errors: {},
        };
      } catch (errors: any) {
        return {
          values: {},
          errors: errors.inner.reduce((allErrors: any, currentError: any) => {
            const error = {
              type: currentError.type ?? 'validation',
              message: currentError.message,
            };

            // Yup reports a nested field as a dotted path ("generation.gs1_prefix"), but React Hook Form
            // looks errors up as a nested object — the same shape `setError` writes. Assigning the dotted
            // string as a literal key would leave those fields with no visible error, so nest it instead.
            if (currentError.path) {
              set(allErrors, currentError.path, error);
              return allErrors;
            }

            return { ...allErrors, [currentError.path]: error };
          }, {}),
        };
      }
    },
    [validationSchema],
  );
